export default (date: number): number => date * 1000;